<template>
  <div class="browser-container">
    <div class="wrapper">
      <h1 class="title">Send your Bitcoins</h1>
      <div class="payment">
        <div class="column">
          <div class="payment-info">
            <span class="payment-title">{{rateDivided }} BTC</span>
            <span class="payment-caption">Send this amount BTC to an address on the right</span>
          </div>
          <div class="payment-info">
            <Countdown time="600" class="payment-title"></Countdown>
            <span class="payment-caption">Time left untill deposit is valid</span>
          </div>
          <router-link to="/step5">
            <button class="button-continue">Open in wallet</button>

            <transition name="fade-tooltip" appear mode="out-in">
              <div class="tooltip-button ">
                <div class="tooltip-body">
                  If the customer hits the “Open in wallet” button, (and they have a bitcoin wallet installed on their phone/PC), the transaction will open in their wallet with the amount and destination address pre-filled. All the customer needs to do is confirm the transaction from their wallet. This is particularly friendly for customers using mobile
                </div>
                <div class="arrow"></div>
              </div>
            </transition>

          </router-link>
        </div>
        <div class="column">
          <svgicon name="qr" width="185" height="185"></svgicon>
          <span class="qr-caption">Qc6yjpBTWgCCVVRTJXsPf959ZL8bbNiBL6</span>
        </div>
        <div class="payment-footer">
          <span class="payment-footer-text">Purchase amount:
            <span class="payment-footer-rate">&#8364;{{ depositAmount }} = {{ rateDivided }} BTC</span>
          </span>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import '../../assets/compiled-icons/index';
import Countdown from '../Countdown.vue';
import Tooltip from '../Tooltip.vue';

export default {
  name: 'Step4',
  components: {
    Countdown,
    Tooltip
  },
  data() {
    return {
      timeoutID: null,
    };
  },
  computed: {
    depositAmount() {
      return this.$store.formattedCurrencyAmount;
    },
    rateDivided() {
      return this.$store.rateDivided;
    }
  },
  // Uncomment if Timeout will be needed
  // created() {
  //   if (this.timeoutID) return;
  //   this.timeoutID = setTimeout(() => {
  //     this.$router.push({ path: '/step5' });
  //   }, 500000000);
  // },
  // destroyed() {
  //   clearTimeout(this.timeoutID);
  //   this.timeoutID = null;
  // }
};
</script>

<style scoped>
@import "../../styles/colors.css";
@import "../../styles/consts.css";

.title {
  margin-bottom: 44px;
}

.payment {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr 73px;
  margin: 0 auto 90px;
  width: 720px;
  height: 409px;
  border-radius: 8px;
  box-shadow: 0 3px 2px -2px $gainsboro;
  background-color: $white;
  border: solid 1px $white-smoke;

  &-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 185px;
    margin-top: 24px;
  }

  &-title {
    @include proxima_regular;
    font-size: 2rem;
    line-height: 0.88;
    letter-spacing: 0.4px;
    text-align: center;
    color: $quartz;
  }

  &-caption {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 26px;
    @include proxima_regular;
    font-size: calc(14rem / 16);
    line-height: 1.71;
    color: $spanish-gray;
  }

  &-footer {
    grid-column: 1 / 3;
    background-color: $ghost-white;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-footer-text {
    @include proxima_regular;
    font-size: calc(14rem / 16);
    color: $gray-blue;
  }

  &-footer-rate {
    @include proxima_semibold;
    font-size: 1rem;
    color: $nickel;
  }
}

.qr-caption {
  font-size: calc(14rem / 16);
  @include proxima_semibold;
  line-height: 1.71;
  text-align: left;
  color: $nickel;
  padding: 0 6px 10px;
  border-bottom: 2px solid $blue;
  margin-top: 33px;
}

.column {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;

  &:first-child {
    padding: 40px 40px 20px;
  }
}

.button-continue {
  width: 250px;
  height: 48px;
  border-radius: 4px;
  background-color: $blue;
  @include proxima_semibold;
  color: $white;
  font-size: 1rem;
  cursor: pointer;
  outline: none;
  border: 0;
  position: relative;

  &:hover {
    background-color: $dark-blue;
  }
}

.tooltip-button {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 0;
  width: 340px;
  min-height: 182px;
  height: auto;
  border-radius: 2px;
  box-shadow: $tooltip-box-shadow;
  background-color: $white;
  border: solid 1px $white-smoke;
  outline: none;
  z-index: 100;
  position: absolute;
  left: -125px;
  top: 235px;

  .arrow {
    border: $white;
    box-shadow: $tooltip-box-shadow;
    transform: scale(-1, -1);

    &:after, &:before {
      right: 100%;
      top: 110px;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-right-color: $white;
      border-width: 12px;
      margin-top: -12px;
    }
    &:before {
      border-right-color: $white-smoke;;
      border-width: 13px;
      margin-top: -13px;
    }
  }

  .tooltip-body {
    flex-grow: 1;
    padding: 20px 30px;
    @include proxima_light;
    font-size: 18px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.78;
    letter-spacing: normal;
    text-align: left;
    color: $spanish-gray;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/Step4.vue